<template>
  <div id="mainDiv" class="rtl">
    <!-- <nav
      class="navbar navbar-expand-lg navbar-light"
      style="background: black; height: 54px; flex-wrap: wrap"
    >
      <div class="navBarTitle align-middle">
        <span style="justify-content: flex-center" class="rtl">{{
          title
        }}</span>
      </div>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 16 16"
        class="bi bi-three-dots-vertical float-right mainMenu"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        data-toggle="collapse"
        data-target="#navbarTogglerDemo01"
        aria-controls="navbarTogglerDemo01"
        aria-expanded="false"
        aria-label="Toggle navigation"
        style="top: 6px; position: relative"
      >
        <path
          fill-rule="evenodd"
          d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"
        />
      </svg> 
    </nav>-->
    <!-- <div style="min-height: calc(100vh - 72px); "> -->
    <div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: "צלילה",
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    lang() {
      return this.translate(this.$store.getters.lang);
    },
  },
  methods: {
    reopenGame() {
      if (localStorage.getItem("navigationName")) {
        this.$router.push("/" + localStorage.getItem("navigationName"));
        location.reload();
      } else {
        this.$router.push("/");
        location.reload();
      }
    },
    restartGame() {
      localStorage.clear();
      this.$router.push("/");
      location.reload();
    },
  },
  name: "App",
};
</script>

<style media="screen">
.mainMenu {
  font-size: 26px;
  margin-bottom: 24px;
  color: white;
}
.logoCarouge {
  height: 51px;
  position: absolute;
  left: 8px;
}
.navBarTitle {
  position: relative;
  margin: 0 auto;
  font-family: "noot";
  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
  font-size: 30px !important;
  bottom: 2px;
  color: white;
  direction: ltr;
  left: 10px;
}
#mainDiv {
  direction: ltr;
  font-family: "Open Sans", sans-serif;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
  background-position: center;
  margin: 0 auto;
}

#app {
  color: rgb(211, 211, 211);
  font-family: "Assistant", sans-serif;
}
.rtl {
  direction: rtl;
}
@media screen and (max-width: 600px) {
}
@font-face {
  font-family: lithos;
  src: url(/static/fonts/LithosPro-Regular.otf);
}
@font-face {
  font-family: noot;
  src: url(/static/fonts/Noot/noot-aj.woff);
}
</style>